export const GET_USAGE_STATS = `
  mutation ($year: Int!, $month: Int) {
    getUsageStats(actualsSearch: {year: $year, month: $month}) {
      data {
        monthToDateUsage
        billings {
          elementMap {
            element1Id
            element2Id
            element3Id
            element4Id
          }
          annual
          monthToDateUsage
          mom
        }
      }
      error {
        code
        message
        statusCode
      }
    }
  }
`
